module.exports = i18n => ({
  button: {
    text: i18n.gettext('Activar'),
  },
  sectionDisabledText: i18n.gettext('Tienes esta sección oculta'),
});
